import {
  TRANSECTIONTYPE_ALL,
  TRANSECTIONTYPE_GET,
  TRANSECTIONTYPE_DEL,
  TRANSECTIONTYPE_PUT,
  TRANSECTIONTYPE_POST,
  TRANSECTIONTYPE_LOADING,
  TRANSECTIONTYPE_ERROR,
  TRANSECTIONTYPE_RESET,
} from '../../actions/types';

const initialState = {
  transectiontypes: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case TRANSECTIONTYPE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case TRANSECTIONTYPE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case TRANSECTIONTYPE_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case TRANSECTIONTYPE_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case TRANSECTIONTYPE_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case TRANSECTIONTYPE_RESET:
      return { transectiontypes: null, isLoading: true, isCompleted: true };
    case TRANSECTIONTYPE_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case TRANSECTIONTYPE_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
